import ApiError from 'api/ApiError'

export const OFFICE_CANCELLATION_CONFLICT_MESSAGE =
	'This shift changed while you were cancelling it. Refresh the shift details, confirm its current status, and try again.'

export const OFFICE_CANCELLATION_GENERIC_MESSAGE =
	'We could not cancel this shift. Refresh the shift details and try again. If the problem continues, contact TempStars Support.'

const getStatus = (error: any): number => Number(error?.status || error?.statusCode || 0)

const getCode = (error: any): string => String(
	error?.data?.code
	|| error?.body?.data?.code
	|| error?.code
	|| '',
)

export const getOfficeCancellationErrorMessage = (error: any): string => {
	const conflict = getStatus(error) === 409
		|| [
			'ADMIN_JOB_SOURCE_STATE_CONFLICT',
			'JOB_MODIFY_SOURCE_STATE_CONFLICT',
		].includes(getCode(error))

	return conflict
		? OFFICE_CANCELLATION_CONFLICT_MESSAGE
		: OFFICE_CANCELLATION_GENERIC_MESSAGE
}

export const toOfficeCancellationDisplayError = (error: any): ApiError | null => {
	if (!error) return null
	return new ApiError(getStatus(error) || 400, getOfficeCancellationErrorMessage(error))
}
